import { render, staticRenderFns } from "./SportelloOspitiView.vue?vue&type=template&id=661b07af&"
import script from "./SportelloOspitiView.vue?vue&type=script&lang=ts&"
export * from "./SportelloOspitiView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports